// WebU brand sites expose window.gbpe. Header shell varies by site generation:
// - GMX: <gmx-injector data-auto-inject="header"> (loads remote AEM fragment)
// - Legacy: <gb-global-nav> (uses .hide property)
const HEADER_SELECTORS = [
    'gmx-injector[data-auto-inject="header"]',
    'gb-global-nav',
];

export function getBrandSiteNav() {
    for (const selector of HEADER_SELECTORS) {
        const nav = document.querySelector(selector);
        if (nav) {
            return nav;
        }
    }
    return null;
}

function applyHeaderHidden(header, hidden) {
    if (header.tagName === 'GB-GLOBAL-NAV') {
        header.hide = hidden;
        return;
    }

    header.style.display = hidden ? 'none' : '';

    if (hidden) {
        header.setAttribute('hidden', '');
    } else {
        header.removeAttribute('hidden');
    }
}

export function setBrandSiteNavHidden(hidden) {
    if (!window.gbpe) {
        return;
    }

    const header = getBrandSiteNav();
    if (!header) {
        return;
    }

    applyHeaderHidden(header, hidden);
}
